// src/components/Experience/Experience.js
import React from 'react';
import './Experience.css';

const Experience = () => {
  return (
    <section className="experience-container">
      <h2 className="experience-title">Professional Experience</h2>
      <p className="experience-subtitle">
        A journey through my career as a Full Stack Developer, Web Developer, and Email Developer, showcasing expertise in campaign analysis, responsive web design, and email marketing solutions.
      </p>

      <div className="experience-timeline">
        {/* Experience 1 */}
        <article className="experience-item">
          <div className="experience-dot"></div>
          <div className="experience-content">
            <h3 className="experience-position">Campaign Analyst</h3>
            <p className="experience-company">Versatiletech, Bangalore, India</p>
            <p className="experience-duration">09/2024 - Present</p>
            <ul className="experience-details">
              <li>
                Identify, troubleshoot, and resolve issues in running campaigns, ensuring seamless user experiences by addressing rendering problems, functionality breakdowns, and behavioral inconsistencies.
              </li>
              <li>
                Conduct detailed assessments of campaign performance, monitoring for operational errors and implementing proactive measures to prevent recurring issues.
              </li>
              <li>
                Maintain comprehensive tracking of campaign issues, collaborating with cross-functional teams to optimize stability and functionality of digital campaigns.
              </li>
            </ul>
          </div>
        </article>

        {/* Experience 2 */}
        <article className="experience-item">
          <div className="experience-dot"></div>
          <div className="experience-content">
            <h3 className="experience-position">Web Developer</h3>
            <p className="experience-company">Aghreni Technologies Pvt. Ltd., Bangalore, India</p>
            <p className="experience-duration">06/2022 - 09/2024</p>
            <ul className="experience-details">
              <li>
                Specialized in developing responsive and interactive email templates, landing pages, and email forms, along with frontend development using HTML, CSS, and JavaScript.
              </li>
              <li>
                Hand-coded HTML and CSS following best practices for email development, utilizing AMPScript and testing with QA tools like Litmus and Email on Acid within Salesforce and Adobe platforms.
              </li>
              <li>
                Leveraged web and graphic design skills with Adobe Photoshop, Illustrator, and Dreamweaver to create visually appealing digital assets.
              </li>
            </ul>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Experience;